<template>
  <b-button :class="className" @click="PlayGame(productId, value)">
    <div class="game-new"><i class="icon icon-new"></i></div>
    <div class="game-soon">
      <b>
        {{ $t("store.soon1") }}
        <q>{{ $t("store.soon2") }}</q>
        <q>{{ $t("store.soon3") }}</q>
        {{ $t("store.soon4") }}
      </b>
    </div>
    <div class="game-uphold">
      <i class="img img-uphold">
        <q>{{ $t("store.uphold_ing") }}</q>
      </i>
    </div>
    <div class="game-logo"></div>
    <div class="game-btn">
      {{ langPlayGame || $t("store.btn.play_game_now") }}
      <i class="icon icon-arrowleft"></i>
    </div>
  </b-button>
</template>
<script>
  import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
  export default {
    name: "gameMod",
    data() {
      return {};
    },
    props: {
      value: { type: Number, default: 0 },
      className: { type: String, default: "" },
      productId: { type: Number, default: 0 },
      langPlayGame: { type: String, default: "" },
    },
    methods: {
      PlayGame(ProductId, GameId) {
        if (this.$auth.$state.loggedIn === false) {
          this.$router.push({ name: 'account-login', params: null, query: null });
          return;
        }

        let GameData = this.Product(ProductId).find(element => element.Id === GameId);
        if (!this.ShowTransferModal && GameData.WalletCode != 'obchess') {
          window.open(GameData.Url);
          return;
        }

        this.setPlayGameData(GameData);
        this.$nextTick(() => this.$root.$emit("bv::toggle::modal", "modalExchPoint", "#btnToggle"));
      },
      ...mapActions("game", ["getPlayGame"]),
      ...mapMutations("game", ["setPlayGameData"]),
    },
    computed: {
      ...mapState(['WebSetting']),
      ...mapGetters(["Product"]),
      ...mapGetters('webSetting', ['ShowTransferModal'])
    },
  };
</script>